export default __webpack_public_path__ + "static/media/clv.285bdad7.svg";